import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"640px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "sb-modal-title" }
const _hoisted_5 = { class: "sb-intro" }
const _hoisted_6 = { class: "sb-chart-scroll" }
const _hoisted_7 = ["viewBox", "aria-label"]
const _hoisted_8 = ["x1", "x2", "y1", "y2"]
const _hoisted_9 = ["x", "y"]
const _hoisted_10 = ["x", "y", "width"]
const _hoisted_11 = ["x", "y", "width", "height"]
const _hoisted_12 = ["d"]
const _hoisted_13 = ["d"]
const _hoisted_14 = ["x", "y"]
const _hoisted_15 = {
  key: 0,
  class: "sb-intro",
  style: {"margin-top":"12px"}
}
const _hoisted_16 = { class: "sb-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.metric.Name), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.ownerName) + " · goal " + _toDisplayString(_ctx.goalText(_ctx.metric, _ctx.weeks[_ctx.weeks.length - 1])) + " · on goal " + _toDisplayString(_ctx.onGoalCount) + " of the last " + _toDisplayString(_ctx.enteredCount) + " weeks", 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock("svg", {
          viewBox: `0 0 ${_ctx.W} ${_ctx.H}`,
          class: "sb-chart",
          role: "img",
          "aria-label": _ctx.metric.Name + ', last 13 weeks against goal'
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.axis.ticks, (t) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: 't' + t
            }, [
              _createElementVNode("line", {
                x1: _ctx.P.l,
                x2: _ctx.W - _ctx.P.r,
                y1: _ctx.y(t),
                y2: _ctx.y(t),
                class: "sb-grid"
              }, null, 8, _hoisted_8),
              _createElementVNode("text", {
                x: _ctx.P.l - 6,
                y: _ctx.y(t) + 4,
                "text-anchor": "end",
                class: "sb-axis"
              }, _toDisplayString(_ctx.formatShort(_ctx.metric, t)), 9, _hoisted_9)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bars, (bar, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: 'b' + i
            }, [
              (bar.value === null)
                ? (_openBlock(), _createElementBlock("rect", {
                    key: 0,
                    x: _ctx.x(i) - _ctx.bw * .3,
                    y: _ctx.y(_ctx.axis.min) - 3,
                    width: _ctx.bw * .6,
                    height: "3",
                    class: "sb-bar-none"
                  }, null, 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("rect", {
                    key: 1,
                    x: _ctx.x(i) - _ctx.bw * .3,
                    y: _ctx.y(bar.value),
                    width: _ctx.bw * .6,
                    height: Math.max(2, _ctx.y(_ctx.axis.min) - _ctx.y(bar.value)),
                    rx: "3",
                    class: _normalizeClass(bar.pass ? 'sb-bar-pass' : 'sb-bar-fail')
                  }, [
                    _createElementVNode("title", null, _toDisplayString(_ctx.weekLabel(bar.week)) + ": " + _toDisplayString(_ctx.formatValue(_ctx.metric, bar.value)) + " (goal " + _toDisplayString(_ctx.goalText(_ctx.metric, bar.week)) + ")", 1)
                  ], 10, _hoisted_11))
            ], 64))
          }), 128)),
          _createElementVNode("path", {
            d: _ctx.goalPath('Goal'),
            class: "sb-goal-line"
          }, null, 8, _hoisted_12),
          (_ctx.hasRange)
            ? (_openBlock(), _createElementBlock("path", {
                key: 0,
                d: _ctx.goalPath('GoalMax'),
                class: "sb-goal-line"
              }, null, 8, _hoisted_13))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (week, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: 'l' + i
            }, [
              (i % 2 == 0 || i == _ctx.weeks.length - 1)
                ? (_openBlock(), _createElementBlock("text", {
                    key: 0,
                    x: _ctx.P.l + i * _ctx.bw + _ctx.bw / 2,
                    y: _ctx.H - 8,
                    "text-anchor": "middle",
                    class: "sb-axis"
                  }, _toDisplayString(_ctx.weekLabel(week)), 9, _hoisted_14))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ], 8, _hoisted_7))
      ]),
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"sb-legend\" data-v-e44f0abe><span data-v-e44f0abe><i class=\"sb-lg-pass\" data-v-e44f0abe></i>On goal</span><span data-v-e44f0abe><i class=\"sb-lg-fail\" data-v-e44f0abe></i>Off goal</span><span data-v-e44f0abe><svg width=\"22\" height=\"8\" data-v-e44f0abe><line x1=\"0\" x2=\"22\" y1=\"4\" y2=\"4\" class=\"sb-goal-line\" data-v-e44f0abe></line></svg> Goal</span></div>", 1)),
      (_ctx.metric.Definition)
        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.metric.Definition), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('enter')))
        }, "Enter or Fix Weeks"),
        _createElementVNode("div", {
          class: "btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, "Done")
      ])
    ])
  ]))
}